import { SelectInput } from 'react-admin';

export const FilterPotentialDealers = ({ choices, ...props }) => {
  const allowedRoles = ['authenticated', 'dealer'];
  const filteredUsers = choices.filter((user) => allowedRoles.includes(user.role.type));
  return <SelectInput choices={filteredUsers} {...props} emptyText={'Všichni'} />;
};
